import InnerPageHome from './innerPageHome'
import TemplateMain from '../templateMain'

export default function PageHome() {
  return (
    <TemplateMain
      g_section="home"
      linksTitle="Technology Stack"
      innerPage={<InnerPageHome />}
      g_sidebarKey="pageHome"
      g_slideshowKey="logos"
    />
  )
}
